import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "address-content"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "address"
};
const _hoisted_4 = {
  class: "name-info"
};
const _hoisted_5 = {
  key: 1,
  class: "no-address"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "delivery-info"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  key: 2
};
import { ref, computed, nextTick } from 'vue';
import { useStore } from 'vuex';
import constants from '@/constants';
import { useRouter } from 'vue-router';
import { handlePromiseTime } from '@/views/spc/spcUtils';
import SelectAddressPop from '@/components/popup/SelectAddressPop.vue';
import { useI18n } from 'vue-i18n';
import { showToastText } from '@/utils/common';
export default {
  __name: 'BuyDeliveryInfo',
  props: {
    asinDetails: {
      type: Object
    },
    addressInfo: {
      type: Object
    },
    isLoading: {
      type: Boolean,
      default: () => false
    }
  },
  emits: ['update:addressInfo', 'changeAddress'],
  setup(__props, {
    expose: __expose,
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const {
      MERCHANT_BADGE_MAP,
      IMAGE_URL
    } = constants;
    const store = useStore();
    const router = useRouter();
    const isLoadSelectAddressPopup = ref(true);
    const selectAddressPopRef = ref(null);
    const cptAddressInfo = computed({
      get: () => props.addressInfo,
      set: val => {
        emit('update:addressInfo', val);
      }
    });
    const showAddressPop = ref(false);
    const handleAddress = () => {
      var _cptAddressInfo$value;
      if ((_cptAddressInfo$value = cptAddressInfo.value) !== null && _cptAddressInfo$value !== void 0 && _cptAddressInfo$value.address) {
        showAddressPop.value = true;
      } else {
        router.push({
          name: 'fillAddress',
          params: {
            type: 'back'
          }
        });
      }
    };
    const changeAddress = item => {
      emit('update:addressInfo', item);
      emit('changeAddress');
    };
    const fillKYC = () => {
      var _cptAddressInfo$value2;
      if (!((_cptAddressInfo$value2 = cptAddressInfo.value) !== null && _cptAddressInfo$value2 !== void 0 && _cptAddressInfo$value2.address)) {
        showToastText(t('modules.checkout.PLEASE_FILL_SHIPPING_ADDRESS_FIRST'));
        return;
      }
      router.push({
        name: 'fillKYC',
        params: {
          fromType: 'spc',
          type: 'add'
        }
      });
    };
    const hasKyc = computed(() => {
      return !!store.state.checkout.fillKYC;
    });
    const getAddressInfo = () => {
      isLoadSelectAddressPopup.value = false;
      nextTick(() => {
        isLoadSelectAddressPopup.value = true;
      });
    };
    const getAddressList = async () => {
      var _selectAddressPopRef$;
      await ((_selectAddressPopRef$ = selectAddressPopRef.value) === null || _selectAddressPopRef$ === void 0 ? void 0 : _selectAddressPopRef$.getAddress());
    };
    __expose({
      getAddressInfo,
      getAddressList,
      showAddressPop
    });
    return (_ctx, _cache) => {
      var _cptAddressInfo$value3, _props$asinDetails$d;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "address-info",
        onClick: handleAddress
      }, [_createElementVNode("img", {
        class: "local-icon",
        src: `${_unref(IMAGE_URL)}assets/svg/local.svg`,
        alt: ""
      }, null, 8, _hoisted_2), (_cptAddressInfo$value3 = cptAddressInfo.value) !== null && _cptAddressInfo$value3 !== void 0 && _cptAddressInfo$value3.address ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("span", _hoisted_3, _toDisplayString(cptAddressInfo.value.address), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(cptAddressInfo.value.name), 1)], 64)) : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(t)('modules.checkout.PLEASE_FILL_SHIPPING_ADDRESS')), 1)), _createElementVNode("img", {
        class: "right-arrow-icon",
        src: `${_unref(IMAGE_URL)}assets/svg/rightArrow.svg`,
        alt: ""
      }, null, 8, _hoisted_6)]), !hasKyc.value && !__props.isLoading ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fill-kyc-content",
        onClick: fillKYC
      }, [_createElementVNode("span", null, _toDisplayString(_unref(t)('common.PLEASE_PROVIDE_THE_KYC_INFO')), 1), _createElementVNode("img", {
        class: "right-arrow-icon",
        src: `${_unref(IMAGE_URL)}assets/svg/rightArrow.svg`,
        alt: ""
      }, null, 8, _hoisted_7)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [__props.asinDetails.merchantId ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: __props.asinDetails.merchantId ? _unref(MERCHANT_BADGE_MAP)[__props.asinDetails.merchantId].badgeURL : '',
        alt: ""
      }, null, 8, _hoisted_9)) : _createCommentVNode("", true), (_props$asinDetails$d = __props.asinDetails.delivery) !== null && _props$asinDetails$d !== void 0 && _props$asinDetails$d.promiseStartTime ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(handlePromiseTime)(__props.asinDetails.delivery)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(t)('modules.checkout.USUALLY_TAKES_A_FEW_DAYS_TO_ARRIVE')), 1))]), isLoadSelectAddressPopup.value ? (_openBlock(), _createBlock(SelectAddressPop, {
        key: 1,
        ref_key: "selectAddressPopRef",
        ref: selectAddressPopRef,
        onChangeAddress: changeAddress,
        show: showAddressPop.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => showAddressPop.value = $event),
        selected: cptAddressInfo.value,
        "onUpdate:selected": _cache[1] || (_cache[1] = $event => cptAddressInfo.value = $event)
      }, null, 8, ["show", "selected"])) : _createCommentVNode("", true)]);
    };
  }
};